import { action, observable } from 'mobx';

class NotificationStore {
  @observable notifications = [];

  @action
  addNotification(notification) {
    this.notifications.push(notification);
  }

  @action
  clearNotifications() {
    this.notifications = [];
  }

  @action
  removeNotification(index) {
    this.notifications.splice(index, 1);
  }
}

export default new NotificationStore();
